import Ajv from "ajv";
export const validationException = (keyword: string, message: string) => {
  return new Ajv.ValidationError([
    {
      params: { keyword },
      keyword,
      message,
    },
  ]);
};
